import React from 'react';

import { LoadableHeadlessProbePostOfficePlacement } from '@atlassian/conversation-assistant-utils/LoadableHeadlessProbePostOfficePlacement';

import { RemoteRovoChatSourcesPostOfficePlacement } from './remote-rovo-chat-sources-post-office-placement';

const renderRemotePlacement = (): React.JSX.Element | null => (
	<RemoteRovoChatSourcesPostOfficePlacement />
);

const ufoCustomDataKeys = {
	result: 'chatSourcesHeadlessProbeResult',
	responseMessageCount: 'chatSourcesHeadlessProbeResponseMessageCount',
	nonDismissedMessageCount: 'chatSourcesHeadlessProbeNonDismissedMessageCount',
};

export const HeadlessProbeRovoChatSourcesPostOfficePlacement = (): React.JSX.Element | null => {
	return (
		<LoadableHeadlessProbePostOfficePlacement
			placementId="rovo-chat-sources"
			renderRemotePlacement={renderRemotePlacement}
			ufoCustomDataKeys={ufoCustomDataKeys}
		/>
	);
};
